import React from 'react';
import { useTranslation } from 'react-i18next';
import './Navigation.css';

const Navigation = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const navItems = [
    { key: 'about', href: '#about' },
    { key: 'music', href: '#music' },
    { key: 'videos', href: '#videos' },
    { key: 'gallery', href: '#gallery' },
    { key: 'events', href: '#events' },
    { key: 'contact', href: '#contact' }
  ];

  const handleClick = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      if (onClose) onClose();
    }
  };

  return (
    <nav className={`navigation ${isOpen ? 'open' : ''}`}>
      <ul className="nav-list">
        {navItems.map((item) => (
          <li key={item.key}>
            <a
              href={item.href}
              onClick={(e) => handleClick(e, item.href)}
              className="nav-link"
            >
              {t(`nav.${item.key}`)}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;

